import { FC } from "react";

export const ButtonBadge: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="absolute right-1 top-1 flex items-center justify-center text-[8px]/[1] font-semibold">
      {children}
    </div>
  );
};
